function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.931 14.484c-.201 3.219-2.294 3.718-2.294 5.904 0 1.443 1.173 2.612 2.62 2.612 1.477 0 2.743-1.378 2.743-3.284 0-1.548-.834-3.443-3.069-5.232zm-.291 4.08c-.03-.537.677-.87.88-1.859.163.232.368.637.391 1.077.067 1.285-1.231 1.566-1.271.782zm-2.054-3.549c-2.316-5.162-8.498-2.12-11.979-4.423-1.76-1.165-2.595-2.87-2.528-4.64-1.224-.294-2.638-.513-4.079-.635l1.136-1.639c4.137.806 8.424 2.351 11.222 4.481-1.087-1.938-4.494-4.183-7.324-5.098 1.134-1.409 2.686-2.061 4.343-2.061 4.895 0 11.054 5.653 9.209 14.015z"
});

function Svg106(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg106);
export default __webpack_public_path__ + "static/media/10_6.f78b563a.svg";
export { ForwardRef as ReactComponent };